import { render, staticRenderFns } from "./Fatture.vue?vue&type=template&id=30a20560&scoped=true"
import script from "./Fatture.vue?vue&type=script&lang=js"
export * from "./Fatture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a20560",
  null
  
)

export default component.exports